import { legacyImageUrlsMapper } from '../../api/legacyCommonMappers';
import type { User } from '../../api/users';
import { checkIsAvailable } from '../../utils/helperFunctions';
import type { SelectListUser } from '../CreateMessage/createMessageSlice/types';

export function mapUserToSelectListUser(
  user: User,
  partial?: Partial<SelectListUser>
): SelectListUser {
  const isAvailable = checkIsAvailable(user.unavailableUntil);
  return {
    id: user.id,
    displayName: user.name,
    title: user.title,
    creatorId: user.id,
    email: user.email,
    photoFileName: legacyImageUrlsMapper.fromCoreToLegacy(user.imageUrls),
    available: isAvailable,
    unavailable: !isAvailable,
    unavailableDateTo: user.unavailableUntil || null,

    ...partial,
  };
}
